import React, { useCallback, useContext } from 'react';
import { MenuItem } from '~/types/Menu';
import { DrawerContext } from '~/providers/DrawerProvider';
import CartPanel from '../';
import { CartItem } from '../../../types/Cart';
import { CartPanelMode } from '../constants';

const useOpenCartPanel = () => {
  const { openDrawer } = useContext(DrawerContext);
  return useCallback(
    ({
      mode,
      item,
      initialValues,
      index,
      onSubmit,
    }: {
      mode?: CartPanelMode;
      item: MenuItem;
      initialValues?: CartItem;
      index?: number;
      onSubmit: (item: CartItem) => void;
    }) => {
      openDrawer(
        ({ closeDrawer }) => {
          const handleSubmit = (cartItem: CartItem) => {
            closeDrawer();
            onSubmit(cartItem);
          };
          return (
            <CartPanel
              mode={mode}
              item={item}
              initialValues={initialValues}
              index={index}
              onSubmit={handleSubmit}
            />
          );
        },
        {
          height: '80%',
          placement: 'bottom',
          closable: true,
        }
      );
    },
    []
  );
};

export default useOpenCartPanel;
